<div class="select-payment-container d-flex flex-column gap-4">
  <div class="payment-detail-container d-flex flex-column gap-4">
    <button type="button" class="btn btn-primary home-btn" (click)="onClickHomeButton()">
      <i class="fa-solid fa-house me-2"></i>Home
    </button>

    <app-custom-modal
      #abortModalRef
      [modalId]="'abortConfirmModal'"
      [title]="'Are you sure?'"
      [message]="'Navigating to the home screen will abort the current court payment process. Do you want to cancel?'"
      [confirmButtonText]="'Yes'"
      [cancelButtonText]="'No'"
      [showConfirmOnly]="false"
      (onCloseModel)="handleAbortModalClose($event)"
    ></app-custom-modal>


  </div>

  <span class="header">Make Payment</span>

  <app-pac-detail [pacDetails]="pacDetails"></app-pac-detail>
  <app-error-banner *ngIf="errorMessage" [message]="errorMessage"></app-error-banner>
  <app-success-banner *ngIf="successMessage" [message]="successMessage"></app-success-banner>
  <app-payment-method [pacDetails]="pacDetails"
                      (pacDetailsUpdated)="onPacDetailsUpdated($event)"
                      [isAborted] = "this.isAborted"
                      [selectedPacCount]="selectedPacCount"
                      (arePaymentMethodsAvailable)="onValidPaymentMethods($event)"
  >
  </app-payment-method>
  <app-payment-collection-details [pacDetails]="pacDetails"></app-payment-collection-details>
</div>
  <app-virtual-keyboard></app-virtual-keyboard>
